import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-ai',
  templateUrl: './home-ai.component.html',
  styleUrls: ['./home-ai.component.scss']
})
export class HomeAIComponent implements OnInit {

  showGpuTiles: boolean = false;

  services = [
    {
      title: 'Windows Cloud',
      description: 'Fully compatible Windows Server instances with SQL Server options for enterprise applications.',
      icon: 'bx bxl-windows',
      link: '/windows-cloud',
      highlight: false,
      gradient: 'from-blue-500 to-indigo-600',
      accent: 'text-blue-600',
      features: ['IIS 10 & .NET', 'SQL Server optional', 'Active Directory ready']
    },
    {
      title: 'Linux Cloud',
      description: 'Optimized Linux distributions with flexible configurations for web applications and development.',
      icon: 'bx bxl-tux',
      link: '/linux-cloud',
      highlight: false,
      gradient: 'from-orange-500 to-amber-600',
      accent: 'text-orange-600',
      features: ['Ubuntu/CentOS/Debian', 'Docker & Kubernetes ready', 'Root access']
    },
    {
      title: 'DevOps Services',
      description: 'Streamline your development lifecycle with our expert DevOps solutions and automation tools.',
      icon: 'bx bx-code-block',
      link: '/devops',
      highlight: true,
      gradient: 'from-cyan-500 to-teal-600',
      accent: 'text-teal-600',
      features: ['CI/CD pipelines', 'Infrastructure as Code', 'Monitoring & alerting']
    },
    {
      title: 'Cloud Services',
      description: 'Comprehensive cloud solutions including migration, management, and optimization.',
      icon: 'bx bx-cloud',
      link: '/cloud-infrastructure',
      highlight: true,
      gradient: 'from-blue-500 to-indigo-600',
      accent: 'text-indigo-600',
      features: ['VPC & networking', 'Load balancers', 'Auto scaling']
    },
    {
      title: 'Storage Cloud',
      description: 'Scalable storage solutions including object storage, block storage, and backup services.',
      icon: 'bx bx-hdd',
      link: '/storage-cloud',
      highlight: false,
      gradient: 'from-purple-500 to-violet-600',
      accent: 'text-purple-600',
      features: ['Object & block storage', 'Snapshots & clones', 'S3-compatible']
    },
    {
      title: 'Managed IT',
      description: 'Proactive IT management and support to keep your business running smoothly.',
      icon: 'bx bx-support',
      link: '/managed-it',
      highlight: false,
      gradient: 'from-blue-500 to-indigo-600',
      accent: 'text-blue-600',
      features: ['24/7 support', 'Patch management', 'Endpoint security']
    },
    {
      title: 'Cloud Migration',
      description: 'Seamless migration of your applications and data to the cloud with minimal downtime.',
      icon: 'bx bx-transfer',
      link: '/cloud-migration',
      highlight: false,
      gradient: 'from-cyan-500 to-teal-600',
      accent: 'text-teal-600',
      features: ['Assessment & planning', 'Zero-downtime strategy', 'Data transfer']
    },
    {
      title: 'Cybersecurity',
      description: 'Advanced security solutions to protect your digital assets from evolving threats.',
      icon: 'bx bx-shield-quarter',
      link: '/cybersecurity',
      highlight: false,
      gradient: 'from-purple-500 to-violet-600',
      accent: 'text-violet-600',
      features: ['WAF & DDoS protection', 'SIEM integration', 'Vulnerability management']
    },
    {
      title: 'Backup & Recovery',
      description: 'Reliable data backup and disaster recovery solutions to ensure business continuity.',
      icon: 'bx bx-data',
      link: '/backup-recovery',
      highlight: false,
      gradient: 'from-orange-500 to-amber-600',
      accent: 'text-amber-600',
      features: ['Automated backups', 'Offsite replication', 'Instant restore']
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
